function FAQ() {
  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-4">FAQ / Help Center</h1>
      <div className="mb-4">
        <h2 className="font-semibold">How do I apply for a job?</h2>
        <p>Login as a candidate, find a job, and click apply.</p>
      </div>
      <div className="mb-4">
        <h2 className="font-semibold">How do employers contact candidates?</h2>
        <p>Employers can use the built-in messaging system.</p>
      </div>
    </div>
  );
}
export default FAQ;
